import { apiFetch, ApiError } from './api-client';

export interface TagOrder {
  id: string;
  status: 'ordered' | 'encoded' | 'posted';
  quantity: number;
  created_at: string;
  encoded_at: string | null;
  posted_at: string | null;
}

export interface TagOrderPatch {
  shopId: string;
  quantity: number;
  contact_name: string;
  business_name: string;
  street: string;
  suburb: string;
  state: string;
  postcode: string;
  phone: string;
  notes: string;
}

/**
 * Throws the server's own reason rather than resolving null — same rule as
 * updateShopSettings, and for the same reason: a swallowed message turns
 * "order_already_open" into "Save failed" and the owner cannot act on it.
 */
export async function createTagOrder(patch: TagOrderPatch): Promise<TagOrder> {
  try {
    const r = await apiFetch<{ order: TagOrder }>('/api/shops/tag-order', {
      action: 'create', ...patch,
    });
    return r.order;
  } catch (err) {
    if (err instanceof ApiError) throw new Error(err.message);
    throw err instanceof Error ? err : new Error('Order failed');
  }
}

/** Null when this shop has never ordered. Never throws — the form still renders. */
export async function getTagOrder(shopId: string): Promise<TagOrder | null> {
  try {
    const r = await apiFetch<{ order: TagOrder | null }>('/api/shops/tag-order', {
      action: 'status', shopId,
    });
    return r.order ?? null;
  } catch {
    return null;
  }
}
